export enum MaternityRisk {
    NO = 'NO',

    MEDIUM = 'MEDIUM',

    HIGH = 'HIGH'
}
